import { RepositoryFactory } from '@/api/RepositoryFactory'

const documentRepository = RepositoryFactory.get('document')

export default {
  namespaced: true,
  state: {
    documentTypes: [],
  },
  getters: {
    getDocumentTypes(state) {
      return state.documentTypes
    },
    getDocumentTypeIdByType(state) {
      return type => {
        const items = state.documentTypes.length
          ? state.documentTypes.filter(item => item.code === type)
          : []

        return items.length > 0 ? items[0].id : 0
      }
    },
    getDocumentByType(state) {
      return type => {
        const items = state.documentTypes.length
          ? state.documentTypes.filter(item => item.code === type)
          : []

        return items.length > 0 ? items[0] : {}
      }
    },
  },
  actions: {
    async init({ commit }) {
      await documentRepository.getTypes().then(response => {
        commit('getFileTypes', response.data)
      })
    },
  },
  mutations: {
    getFileTypes(state, data) {
      state.documentTypes = data
    },
  },
}
